import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import GlobalStyles from "./styles/Global.styled";
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsxs(React.StrictMode, { children: [_jsx(GlobalStyles, {}), _jsx(App, {})] }));
